import { State } from '../index';

/**
 * Helper function to help determine which part of the UI
 * needs to be updated based on state changes
 * @param {State} newState - new state
 * @param {State} oldState - old state
 * @returns {Object} - object containing booleans
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const formChanged = JSON.stringify(state.form) !== JSON.stringify(oldState.form);
    const resultChanged = state.result !== oldState.result;
    const errorChanged = state.error !== oldState.error;

    return {
        button: formChanged,
        result: resultChanged,
        error: errorChanged,
    };
};
